var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1024,
    viewBox: "0 0 1440 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_132_1388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.11,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.224,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.333,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.443,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.557,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.667,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.776,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0L-36 1100",
    stroke: "#EF5A3C",
    strokeOpacity: 0.89,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 0L-36 1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67,
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1964 0L-36 1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5964 0L-36 1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67,
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 0L1964 600",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67,
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 0L1964 470",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67,
    strokeDasharray: "5 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M724 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M824 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1004 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1164 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1204 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1244 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1324 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1364 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1404 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424 0V1100",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.11,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.224,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.333,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.443,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.557,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.667,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.776,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1384 0V1100",
    stroke: "#CF74A2",
    strokeOpacity: 0.89,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 20H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 40H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 60H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 80H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 120H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 140H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 160H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 180H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 200H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 220H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 240H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 260H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 280H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 300H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 320H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 340H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 360H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 380H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 420H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 440H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 460H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 480H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 500H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 520H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 540H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 560H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 580H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 600H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 620H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 640H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 660H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 680H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 700H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 720H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 740H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 760H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 780H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 800H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 820H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 840H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 860H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 880H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 900H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 920H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 940H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 960H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 980H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 1000H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 1020H1964",
    stroke: "black",
    strokeOpacity: 0.05,
    strokeWidth: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.89,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.776,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.667,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.557,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.443,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.333,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.224,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 100H1964",
    stroke: "#0CA063",
    strokeOpacity: 0.11,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.11,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.224,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.333,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.443,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.557,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.667,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.776,
    strokeDasharray: "0.01 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-36 400H1964",
    stroke: "#2797CF",
    strokeOpacity: 0.89,
    strokeDasharray: "0.01 1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_132_1388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.0974071fcd749becb2cf1621e8df923c.svg";
export { ForwardRef as ReactComponent };